// extracted by mini-css-extract-plugin
export var container = "blogs-module--container--z-Oy3";
export var description = "blogs-module--description--s9UIk";
export var info = "blogs-module--info--w5DhT";
export var infoContainer = "blogs-module--infoContainer--P+N4J";
export var main = "blogs-module--main--bPXHe";
export var title = "blogs-module--title--PlosM";